import { FULFILLMENT_FILTER_OPTIONS } from "@/utils/orderFilters.js";
import CustomerFilterField from "@/components/CustomerFilterField.jsx";
import FilterToolboxShell from "@/components/FilterToolboxShell.jsx";

export default function OrderFilterToolbox({
    filters,
    loading = false,
    onChange,
    onApply,
    onReset
}) {
    return (
        <FilterToolboxShell loading={loading} onApply={onApply} onReset={onReset}>
            {({ closeMobile }) => (
                <>
                    <label className="field">
                        Recherche
                        <input
                            type="search"
                            placeholder="Produit, client, adresse..."
                            value={filters.search}
                            onChange={(e) => onChange({ ...filters, search: e.target.value })}
                        />
                    </label>

                    <CustomerFilterField
                        value={filters.customer}
                        onChange={(customer) => onChange({ ...filters, customer })}
                        onCustomerSelect={async (customer) => {
                            const nextFilters = { ...filters, customer };
                            onChange(nextFilters);
                            await onApply(nextFilters);
                            closeMobile();
                        }}
                        disabled={loading}
                    />

                    <label className="field field--status">
                        Mode de réception
                        <select
                            value={filters.fulfillmentType}
                            onChange={(e) => onChange({ ...filters, fulfillmentType: e.target.value })}
                        >
                            {FULFILLMENT_FILTER_OPTIONS.map((option) => (
                                <option key={option.value || "all"} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </label>

                    <label className="field field--amount">
                        Prix min (FCFA)
                        <input
                            type="number"
                            min="0"
                            step="1"
                            placeholder="Min"
                            value={filters.priceMin}
                            onChange={(e) => onChange({ ...filters, priceMin: e.target.value })}
                        />
                    </label>

                    <label className="field field--amount">
                        Prix max (FCFA)
                        <input
                            type="number"
                            min="0"
                            step="1"
                            placeholder="Max"
                            value={filters.priceMax}
                            onChange={(e) => onChange({ ...filters, priceMax: e.target.value })}
                        />
                    </label>

                    <label className="field field--date">
                        Date à partir du
                        <input
                            type="date"
                            value={filters.dateFrom}
                            onChange={(e) => onChange({ ...filters, dateFrom: e.target.value })}
                        />
                    </label>

                    <label className="field field--date">
                        Date jusqu&apos;au
                        <input
                            type="date"
                            value={filters.dateTo}
                            onChange={(e) => onChange({ ...filters, dateTo: e.target.value })}
                        />
                    </label>
                </>
            )}
        </FilterToolboxShell>
    );
}
